/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NumberOfAlarms } from './numberOfAlarms';


export interface StatusCodeValueNumberOfAlarms { 
    value?: NumberOfAlarms;
    status_code?: number;
}

